class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
  }

  onSummaryClick(event) {
    // Habang tumatakbo ang 300ms close animation, may `open` pa rin ang
    // details — kaya ang click na dapat mag-re-open ay nagto-toggle pa
    // sana pasara ("dead click": kailangan ng dalawang click). Kanselahin
    // ang pending close at ituring na re-open ang click na ito.
    if (!this.mainDetailsToggle.classList.contains('is-closing')) return;
    event.preventDefault();
    clearTimeout(this.closeTimer);
    this.mainDetailsToggle.classList.remove('is-closing');
    // Ang aria-flipper ng global.js (nauna sa listener na ito) ay nagbasa
    // ng still-open na state at nag-set ng "false" — itama pabalik.
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.classList.add('is-closing');
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('is-closing');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }, 300);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
